import type { ComponentPropsWithoutRef } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

interface CustomCheckboxProps
  extends ComponentPropsWithoutRef<typeof Checkbox> {
  id: string;
}

export const CustomCheckbox = ({
  id,
  className,
  ...props
}: CustomCheckboxProps) => {
  return (
    <Checkbox
      id={id}
      className={cn(
        "rounded-sm shadow-none border-gray-950 data-[state=checked]:bg-gray-950 data-[state=checked]:text-gray-50 cursor-pointer",
        className
      )}
      {...props}
    />
  );
};
